<template>
	<div class="resetpwd" :style="{ height: `${windowHeight}px`}">
		<el-row>
				<el-col :span="8"><span style="color:#ffffff">占</span></el-col>
				<el-col :span="8">
					<el-card class="box-card" shadow="hover">
						<div slot="header" class="clearfix">
							<span>用户信息</span>
						</div>
						<table class="htmltable">
							<tr>
								<td>
									<span>用户账号:</span>
								</td>
								<td>
									<span>{{userinfo.u_account}}</span>
								</td>
							</tr>
							<tr v-if="!showreset">
								<td>
									<span>密  码:</span>
								</td>
								<td>
									<el-link @click="showresetinput">重置密码</el-link>
								</td>
							</tr>
							<tr v-if="showreset">
								<td>
									<span>原密码:</span>
								</td>
								<td>
									<el-input v-model="oldpwd" type="password" size="mini"></el-input>
								</td>
							</tr>
							<tr v-if="showreset">
								<td>
									<span>新密码:</span>
								</td>
								<td>
									<el-input v-model="newpwd" type="password" size="mini"></el-input>
								</td>
							</tr>
							<tr v-if="!showreset">
								<td>
									<span>用户姓名:</span>
								</td>
								<td>
									<span>{{userinfo.u_name}}</span>
								</td>
							</tr>
							<tr v-if="!showreset">
								<td>
									<span>会员卡:</span>
								</td>
								<td>
									<span>{{userinfo.vipaccount}}</span>
								</td>
							</tr>
							<tr v-if="!showreset">
								<td>
									<span>账户余额:</span>
								</td>
								<td>
									<span>{{userinfo.ye}}</span>
								</td>
							</tr>
							<tr v-if="showreset">
								<td colspan="2" style="text-align: center;">
									<el-button type="success" @click="savepwd" size="mini">确认重置</el-button>
									<el-button @click="showreset=false" size="mini">取消</el-button>
								</td>
							</tr>
						</table>
					</el-card>
				</el-col>
				<el-col :span="8"><span style="color:#ffffff"></span></el-col>
			</el-row>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	props: {
		
	},
	data() {
		return {
			windowHeight: window.innerHeight - 130,
			userinfo:{
				u_account:localStorage.getItem('u_account'),
				u_name:localStorage.getItem('u_name'),
				vipaccount:localStorage.getItem('vipaccount'),
				ye:0
			},
			oldpwd:'',
			newpwd:'',
			showreset:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/user/resetpwd.scss');
		});
		this.getvipaccount();
	},
	methods: {
		getvipaccount(){
			 var that=this;
			 if(this.vipaccount!=''){
				this.$apipost.get.getvipbyvipaccount({vipaccount:this.userinfo.vipaccount}).then(res => {
					if(res.ye!='')
					 that.userinfo.ye=res.ye;
				});
			  }
		},
		showresetinput(){
			this.showreset=true;
			this.oldpwd='';
			this.newpwd='';
		},
		//保存密码
		savepwd(){
			var that=this;
			this.$apipost.post.SavePwd({paraminfo:this._data}).then(res => {
				if(res.state=='1'){
					this.$tool.message('保存成功', 1);
					that.showreset=false;
				}else{
					this.$tool.message(res.message, 0);
				}
			});
		}
	}
}
		
</script>

<style>
</style>
